import { client } from './client';
import {
  AddEventObj,
  AttendEventObj,
  NewSongObject,
  NewVideoObject,
} from '../interfaces/fetchUtilsInterface';
import { RealtimeChannel } from '@supabase/supabase-js';
import { ChatMessages, Merch } from '../interfaces/userInterfaces';
import { Dispatch, SetStateAction } from 'react';
import { parseImagePath } from './parseImagePath';

export const authListener = () => {
  client.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_OUT') {
      // delete cookies on sign out
      const expires = new Date(0).toUTCString();
      document.cookie = `my-access-token=; path=/; expires=${expires}; SameSite=Lax; secure`;
      document.cookie = `my-refresh-token=; path=/; expires=${expires}; SameSite=Lax; secure`;

      // REMOVE LOG AFTER DEV
      console.log('!!!!!COOKIES REMOVED FROM USER AUTH!!!!!');
      // REMOVE LOG AFTER DEV
    } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
      const maxAge = 24 * 60 * 60; // 1 Day
      document.cookie = `my-access-token=${session?.access_token}; path=/; max-age=${maxAge}; SameSite=Lax; secure`;
      document.cookie = `my-refresh-token=${session?.refresh_token}; path=/; max-age=${maxAge}; SameSite=Lax; secure`;
    }
  });
};

// export const fetchUser = () => {
//   // Check for cookie set in UserProvider
//   const cookieAuth = document?.cookie || null;
//   const cookies = cookieAuth ? stringParser(document?.cookie) : {};
//   const refreshToken = cookies['my-refresh-token'];
//   const accessToken = cookies['my-access-token'];

//   // If user has valid cookies, update user session
//   if (refreshToken && accessToken) {
//     client.auth.setSession({
//       refresh_token: refreshToken,
//       access_token: accessToken,
//     });
//   } else {
//     // make sure you handle this case!
//     console.log('YOU ARE NOT LOGGED IN');
//     throw new Error('User is not authenticated.');
//   }

//   // returns user information
//   console.log('CLIENT.AUTH', client);

//   return client.auth;
// };

export const signUpUser = async (email: string, password: string) => {
  const response = await client.auth.signUp({ email, password });
  return response.data;
};

export const signInUser = async (email: string, password: string) => {
  try {
    const response = await client.auth.signInWithPassword({
      email,
      password,
    });
    console.log('RESPONSE FROM SIGN IN ATTEMPT', response);
    return response;
  } catch (error) {
    console.log('SIGN IN ATTEMPT FAILED: ', error);
  }
  // const response = await client.auth.signInWithPassword({
  //   email,
  //   password,
  // });
  // console.log('RESPONSE FROM SIGN IN ATTEMPT', response);
  // return response;
};

export const logoutUser = async () => {
  await client.auth.signOut();
  // return location.replace('../auth');
};

export const fetchUserProfile = async (user_id: string) => {
  const profile = await client
    .from('profiles')
    .select(
      '*, videos:video_uploads(*), songs:songs(*), merch:merchandise(*), wallet(balance), attending_event(*, event:events(*)), user_events:events(*)'
    )
    .match({ user_id })
    .single();

  console.log('SHOW ME THE ERROR', profile);

  return profile;
};

export const fetchProfileById = async (id: string) => {
  const profile = await client
    .from('profiles')
    .select(
      '*, videos:video_uploads(*), songs:songs(*), merch:merchandise(*), attending_event(*, event:events(*)), user_events:events(*)'
    )
    .match({ id })
    .single();
  console.log('PROFILE IN FETCH CALL!!!', profile);
  return profile;
};

export const fetchUserEvents = async (user_id: string) => {
  const res = await client
    .from('profiles')
    .select('attending_event(*, event:events(*)), user_events:events(*)')
    .match({ user_id })
    .single();
  return res;
};

export const fetchLatestVideos = async () => {
  const allVideos = await client
    .from('video_uploads')
    .select('*, profile:profiles(id, avatar_url)')
    .order('created_at')
    .limit(15);
  if (allVideos.data) {
    return allVideos;
  } else return null;
};

export const getVideoById = async (video_id: number) => {
  const video = await client.from('video_uploads').select().match({ video_id }).single();
  return video;
};

export const updateViews = async (video_id: number) => {
  const viewCount = await client.from('video_uploads').select('views').match({ video_id }).single();
  const newCount = viewCount?.data?.views + 1;
  const response = await client
    .from('video_uploads')
    .update({ views: newCount })
    .eq('video_id', video_id)
    .select();
  return response;
};

export const fetchLatestSongs = async () => {
  const allSongs = await client
    .from('songs')
    .select('*, profile:profiles(id, avatar_url)')
    .order('created_at')
    .limit(50);
  if (allSongs.data) {
    return allSongs;
  } else return null;
};

// export const searchFeature = async (query: string) => {
//   const searchResultsUser = await client
//     .from('profiles')
//     .select('*')
//     .ilike('username', `%${query}%`);

//   const searchResultsVideos = await client
//     .from('video_uploads')
//     .select(`*`)
//     .or(`description.ilike.%${query}%,title.ilike.%${query}%`);

//   const searchResultsSongs = await client
//     .from('songs')
//     .select(`*`)
//     .or(`description.ilike.%${query}%,title.ilike.%${query}%`);

//   const searchResults = searchResultsUser?.data?.concat(
//     searchResultsVideos.data,
//     searchResultsSongs.data
//   );
//   return searchResults;
// };

export const addEvent = async ({ eventName, date, time, address, user_id }: AddEventObj) => {
  const response = await client
    .from('events')
    .insert({ event_name: eventName, date, time, address, user_id })
    .select('*')
    .single();

  await attendEvent({ event_id: response.data.id, user_id });

  console.log('RESPONSE FROM ADD EVENT', response);

  return response;
};

export const attendEvent = async ({ event_id, user_id }: AttendEventObj) => {
  const response = await client.from('attending_event').insert({ event_id, user_id }).select('*');
  return response;
};

export const fetchLatestEvents = async () => {
  const allEvents = await client
    .from('events')
    .select('*, profiles(username)')
    .order('date')
    .limit(15);
  if (allEvents.data) {
    return allEvents;
  }
};

export const followUser = async (followObj: {}) => {
  const response = await client.from('follows').insert(followObj);
  console.log('RESPONSE FROM FOLLOW', response);
  return response;
};

export const addEventToAttending = async (event_id: number, user_id: string) => {
  const response = await client.from('attending_event').insert({ event_id, user_id }).select('*');
  return response;
};

export const cancelAttendEvent = async (event_id: number, user_id: string) => {
  const response = await client
    .from('attending_event')
    .delete()
    .match({ event_id, user_id })
    .single();
  return response;
};

export const deleteEventRow = async (id: number) => {
  const response = await client.from('events').delete().match({ id }).single();
  return response;
};

export const getEventById = async (id: string) => {
  const response = await client
    .from('events')
    .select(`*, attending_event(count)`)
    .match({ id })
    .single();
  return response;
};

const addNewVideoToBucket = async (user_id: string, media: File) => {
  const response = await client.storage.from('videos').upload(`${user_id}/${media.name}`, media, {
    cacheControl: '3600',
    upsert: false,
  });
  return response;
};

export const uploadNewVideo = async (newVideo: NewVideoObject, media: File, user_id: string) => {
  const response = await client.from('video_uploads').insert(newVideo);

  await addNewVideoToBucket(user_id, media);

  return response;
};

const removeVideoFromBucket = async (user_id: string, name: string) => {
  console.log('DATA IN REMOVE VIDEO FROM BUCKET', user_id, name);

  const response = await client.storage.from('videos').remove([`${user_id}/${name}`]);
  console.log('RESPONSE FROM VIDEO DELETE', response);

  return response;
};

export const deleteUserVideo = async (user_id: string, mediaName: string, video_id: number) => {
  const response = await client.from('video_uploads').delete().eq('video_id', video_id);

  console.log('RESPONSE FROM DELETE USER VIDEO', response);
  if (!response.error) {
    await removeVideoFromBucket(user_id, mediaName);
    return response;
  } else {
    throw new Error(response.error.message);
  }
};

export const editUserVideo = async (video_id: number, title: string, description: string) => {
  console.log('TITLE: ', title, 'DESCRIPTION: ', description);

  const response = await client
    .from('video_uploads')
    .update({ title, description })
    .eq('video_id', video_id)
    .select();
  console.log('RESPONSE FROM USER VIDEO EDIT', response);
  if (!response.error) {
    return response;
  } else {
    console.log('AN ERROR OCCURRED IN USER EDIT VIDEO CALL');
  }
};

export const updateUserVideoArray = async (user_id: string) => {
  const updatedUserVideoArray = await client
    .from('profiles')
    .select('videos:video_uploads(*)')
    .match({ user_id })
    .single();

  console.log('SHOW ME THE ERROR', updatedUserVideoArray);

  return updatedUserVideoArray;
};

const addNewSongToBucket = async (user_id: string, media: File) => {
  const response = await client.storage.from('songs').upload(`${user_id}/${media.name}`, media, {
    cacheControl: '3600',
    upsert: false,
  });
  console.log('RESPONSE FROM UPLOAD TO SONG BUCKET', response);

  return response;
};

export const uploadNewSong = async (newSong: NewSongObject, media: File, user_id: string) => {
  const response = await client.from('songs').insert(newSong);

  await addNewSongToBucket(user_id, media);

  return response;
};

export const updateUserSongArray = async (user_id: string) => {
  const updatedUserSongArray = await client
    .from('profiles')
    .select('songs:songs(*)')
    .match({ user_id })
    .single();

  console.log('SHOW ME THE ERROR', updatedUserSongArray);

  return updatedUserSongArray;
};

export const chatSubscription = (
  updateMessagePayload: Dispatch<SetStateAction<any>>,
  username: string
) => {
  const response = client
    .channel(username)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'chat_messages',
        filter: `sender=eq.${username}`,
      },
      (payload) => {
        // console.log('ACTION DETECTED', payload);
        updateMessagePayload && updateMessagePayload(payload);
      }
    )
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'chat_messages',
        filter: `receiver=eq.${username}`,
      },
      (payload) => {
        // console.log('ACTION DETECTED', payload);
        updateMessagePayload && updateMessagePayload(payload);
      }
    )
    .subscribe();
  // console.log('RESPONSE FROM SUBSCRIBE', response);

  return response;
};

export const removeChatSubscription = async (sub: RealtimeChannel) => {
  const response = await client.removeChannel(sub);
  // console.log('RESPONSE FROM REMOVE', response);
  return response;
};

export const fetchChats = async (username: string) => {
  const response = await client
    .from('chats')
    .select('*, messages:chat_messages(*)')
    .or(`user_1.eq.${username},user_2.eq.${username}`)
    .order('message_created_at', { referencedTable: 'chat_messages', ascending: true });
  // console.log('RESPONSE IN CHAT MESSAGES FETCH CALL', response);

  return response;
};

export const fetchSingleChat = async (chat_id: number) => {
  const response = await client
    .from('chats')
    .select('*, messages:chat_messages(*)')
    .match({ chat_id })
    .order('message_created_at', { referencedTable: 'chat_messages', ascending: true })
    .single();
  // console.log('RESPONSE IN CHAT MESSAGES FETCH CALL', response);

  return response;
};

export const initiateChat = async (user_1: string, user_2: string) => {
  const response = await client.from('chats').insert([{ user_1, user_2 }]).select();

  return response;
};

export const uploadNewMessage = async (newMessage: ChatMessages) => {
  const response = await client.from('chat_messages').insert([newMessage]).select().single();
  // console.log('RESPONSE FROM NEW MESSAGE UPLOAD', response);

  return response;
};

export const editChatMessage = async (id: number, message: string) => {
  const response = await client.from('chat_messages').update({ message }).match({ id });
  // console.log('RESPONSE FROM EDIT CHAT MESSAGE', response);
  return response;
};

export const deleteChat = async (id: number) => {
  const response = await client.from('chat_messages').delete().match({ id });
  // console.log('RESPONSE FROM DELETE CHAT MESSAGE', response);
  return response;
};

export const closeChat = async (chat_id: number) => {
  const response = await client.from('chats').delete().match({ chat_id }).single();
  console.log('RESPONSE FROM DELETE CHAT MESSAGE', response);
  return response;
};

export const fetchArtistWalletBalance = async (user_id: string) => {
  const res = await client.from('wallet').select('balance').match({ user_id }).single();
  console.log('RESPONSE FROM ARTIST WALLET BALANCE REQUEST', res);
  return res.data;
};

export const donateToArtist = async (amount: number, user_id: string) => {
  const res = await client
    .from('wallet')
    .update({ balance: amount })
    .match({ user_id })
    .select()
    .single();
  console.log('RESPONSE FROM ARTIST DONATION', res, user_id);
  return res.data;
};

export const updateWalletAfterDonate = async (amount: number, user_id: string) => {
  const res = await client
    .from('wallet')
    .update({ balance: amount })
    .match({ user_id })
    .select()
    .single();
  console.log('RESPONSE FROM UPDATE WALLET AFTER DONATE', res, user_id);
  return res.data;
};

// export const deleteProductById = async (id: number) => {
//   const response = await client.from('merchandise').delete().match({ id });
//   if (response && response.data) {
//     const imagePath = parseImagePath(response.data[0].image);
//     const deleteProductImage = await client.storage
//       .from('product_images')
//       .remove([`/${imagePath}`]);
//     console.log('RESPONSE FROM DELETE PRODUCT', response);
//     console.log('RESPONSE FROM DELETE PRODUCT IMAGE', deleteProductImage);
//   }
//   return response;
// };

const productImageUpload = async (media: File) => {
  const response = await client.storage.from('product_images').upload(`${media.name}`, media, {
    cacheControl: '3600',
    upsert: true,
  });
  return response;
};

export const insertProduct = async (data: Merch, media: File) => {
  const response = await client.from('merchandise').insert(data);

  const imageUpload = await productImageUpload(media);

  console.log('RESPONSE FROM PRODUCT INSERT', response);
  console.log('IMAGE BUCKET RESPONSE FROM INSERT', imageUpload);
  return response.data;
};
